// @ts-ignore
import request from "../utils/request";

// 定义请求参数和响应的通用类型
type Method = "get" | "post" | "put" | "delete" | "patch";

interface RequestOptions {
  url: string;
  method: Method;
  params?: Record<string, any>;
  data?: any;
  responseType?:
    | "arraybuffer"
    | "blob"
    | "document"
    | "json"
    | "text"
    | "stream";
  headers?: Record<string, string>;
}

/**
 * GET 请求
 * @param api - 请求的 API 地址
 * @param params - URL 查询参数
 * @param responseType - 响应数据类型
 * @returns Promise 响应结果
 */
export function requestByGet<T = any>(
  api: string,
  params?: Record<string, any>,
  responseType?: RequestOptions["responseType"]
): Promise<T> {
  return request<T>({
    url: api,
    method: "get",
    params,
    responseType,
  });
}

/**
 * POST 请求 (默认表单格式)
 * @param api - 请求的 API 地址
 * @param formData - 请求体数据
 * @param params - URL 查询参数
 * @param headers - 请求头配置
 * @returns Promise 响应结果
 */
export function requestByPost<T = any>(
  api: string,
  formData?: any,
  params?: Record<string, any>,
  headers?: Record<string, string>
): Promise<T> {
  return request<T>({
    url: api,
    method: "post",
    data: formData,
    params,
    headers,
  });
}

/**
 * POST 请求 (JSON格式)
 * @param api - 请求的 API 地址
 * @param jsonData - 要发送的JSON数据
 * @param params - URL 查询参数
 * @param headers - 额外的请求头配置
 * @returns Promise 响应结果
 */
export function requestByPostJson<T = any>(
  api: string,
  jsonData?: any,
  params?: Record<string, any>,
  headers?: Record<string, string>
): Promise<T> {
  // 合并默认的JSON头和用户自定义头，用户头会覆盖默认头
  const defaultHeaders = {
    "Content-Type": "application/json;charset=UTF-8",
  };

  return request<T>({
    url: api,
    method: "post",
    data: jsonData,
    params,
    headers: { ...defaultHeaders, ...headers },
  });
}

/**
 * PUT 请求
 * @param api - 请求的 API 地址
 * @param formData - 请求体数据
 * @returns Promise 响应结果
 */
export function requestByPut<T = any>(
  api: string,
  formData?: any,
  params?: Record<string, any>
): Promise<T> {
  return request<T>({
    url: api,
    method: "put",
    params,
    data: formData,
  });
}

/**
 * DELETE 请求
 * @param api - 请求的 API 地址
 * @param ids - 要删除的 ID 列表或单个 ID
 * @returns Promise 响应结果
 */
export function requestByDelete<T = any>(api: string, ids?: any): Promise<T> {
  return request<T>({
    url: api,
    method: "delete",
    data: ids,
  });
}
